import { useContent } from "../context/ContentContext";
import { resolveAsset } from "../lib/api";
import { ArrowUpRight, ImageIcon } from "lucide-react";

export const Proyectos = () => {
  const { content } = useContent();
  return (
  <section id="proyectos" data-testid="proyectos-section" className="section-anchor bg-[#081A4D]/60 backdrop-blur-[2px] py-24 lg:py-32">
    <div className="max-w-6xl mx-auto px-5 sm:px-8">
      <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#8AB0FF] mb-4 reveal">Mis Proyectos</p>
      <h2 className="font-serif-display text-3xl sm:text-4xl font-semibold text-white mb-12 reveal">
        Comunicación, comunidad y emprendimiento
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
        {(content.projects || []).map((p) => (
          <article
            key={p.id}
            data-testid={`project-card-${p.id}`}
            className="project-card rounded-2xl p-7 sm:p-8 flex flex-col reveal"
          >
            {p.logo ? (
              <div className="h-24 flex items-center justify-start mb-6">
                <img
                  data-testid={`project-logo-${p.id}`}
                  src={resolveAsset(p.logo)}
                  alt={p.logoLabel}
                  className="max-h-24 w-auto max-w-[220px] object-contain"
                />
              </div>
            ) : (
              <>
                <div
                  data-testid={`project-logo-placeholder-${p.id}`}
                  className="photo-placeholder rounded-xl h-20 w-20 flex items-center justify-center mb-6"
                  title={p.logoLabel}
                >
                  <ImageIcon className="text-[#C0C7D1]" size={24} />
                </div>
                <p className="text-[11px] uppercase tracking-[0.2em] text-neutral-500 mb-2">{p.logoLabel}</p>
              </>
            )}
            <h3 className="font-serif-display text-2xl font-semibold text-[#101828]">{p.title}</h3>
            <p className="text-neutral-600 mt-3 leading-relaxed flex-1">{p.description}</p>
            {p.link && (
              <a
                href={p.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`project-link-${p.id}`}
                className="btn-outline-blue rounded-full px-5 py-2.5 text-sm font-medium inline-flex items-center gap-2 mt-6 self-start"
              >
                {p.linkLabel || "Visitar sitio"} <ArrowUpRight size={16} />
              </a>
            )}
          </article>
        ))}
      </div>
    </div>
  </section>
  );
};
